import { Candidate } from '../models/Candidate/Candidate';

export const candidateNeedsToUpdatePersonalData = (candidate?: Partial<Candidate>): boolean => (
    !candidate
        || !candidate.firstName
        || !candidate.lastName
        || !candidate.dateOfBirth
        || !candidate.gender
);
